import { network } from 'services/network';

export const getNotificationStatus = () => {
    return network.get('api/bo/notification/getNotificationStatus').then((response) => response.data);
};
